module.exports = __webpack_public_path__ + "static/media/testimonial.1987013f.jpg";